module.exports = __webpack_public_path__ + "static/media/Hekmat.b1405f8e.svg";